import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useState } from "react";
import Sidebar from "../components/Sidebar";

export default function Admin() {
  const { token } = useSelector((state) => state.auth);
  const location = useLocation();
  const [isExpanded, setIsExpanded] = useState(true);

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace={true} />;
  }

  return (
    <div className="admin-shell">
      <Sidebar
        isExpanded={isExpanded}
        onToggleExpanded={() => setIsExpanded(!isExpanded)}
      />
      <main className="admin-main">
        <div className="admin-content-card">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
